module.exports = __webpack_public_path__ + "ba118927.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img/dl_andriod_blue@2x.png
// module id = 1025
// module chunks = 0